// extracted by mini-css-extract-plugin
module.exports = {"col_box":"col_box-3SZq5Ma6","col_navlist":"col_navlist-3ixTRXsk"};